import type { Question, QuestionStimulus, QuestionType } from '@examflow/core';

/**
 * TCF 考试等级
 */
export enum TCFLevel {
  A1 = 'A1',
  A2 = 'A2',
  B1 = 'B1',
  B2 = 'B2',
  C1 = 'C1',
  C2 = 'C2',
}

/**
 * TCF 考试部分
 */
export enum TCFSection {
  /** 听力理解 */
  LISTENING = 'listening',
  /** 语言结构（语法和词汇） */
  LANGUAGE_STRUCTURES = 'language_structures',
  /** 阅读理解 */
  READING = 'reading',
  /** 口语表达（可选） */
  SPEAKING = 'speaking',
  /** 书面表达（可选） */
  WRITING = 'writing',
}

/**
 * TCF 题目扩展接口
 */
export interface TCFQuestion extends Question {
  /** 对应的 TCF 等级 */
  tcfLevel: TCFLevel;
  /** 所属考试部分 */
  section: TCFSection;
  /** 题目序号（在该部分中） */
  orderInSection?: number;
}

/**
 * TCF 听力题目（single_choice + audio stimulus）
 */
export interface TCFListeningQuestion extends TCFQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'audio'>[];
  /** 音频URL */
  audioUrl: string;
  /** 音频播放次数限制 */
  maxPlayCount?: number;
  /** 音频时长（秒） */
  audioDuration?: number;
}

/**
 * TCF 阅读题目（single_choice + passage stimulus）
 */
export interface TCFReadingQuestion extends TCFQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'passage'>[];
  /** 阅读材料 */
  passage: string;
  /** 材料来源 */
  source?: string;
}

/**
 * TCF 分数与等级对照表
 */
export interface TCFScoreMapping {
  level: TCFLevel;
  minScore: number;
  maxScore: number;
  cefrEquivalent: string;
  description: string;
}

/**
 * TCF 考试结果
 */
export interface TCFResult {
  /** 总分 */
  totalScore: number;
  /** 等级 */
  level: TCFLevel;
  /** 各部分得分 */
  sectionScores: Record<TCFSection, number>;
  /** CEFR 等级 */
  cefrLevel: string;
  /** 详细评价 */
  evaluation: string;
}
